import React, { useMemo } from "react";
import { Form, Row, Col, FormGroup, Input, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "components/Select";
import { getActiveColorStyle } from "utils/colorUtils";
import {
  getTheme2SearchFilterColProps,
  getTheme2SearchFilterSingleSelectStyles,
} from "utils/theme2MultiSelect";

const UsersFilters = ({
  activeColor = "secondary",
  isTheme2 = false,
  searchInput,
  onSearchChange,
  searchLabel,
  searchPlaceholder = "Search users...",
  showTenantFilter = false,
  onTenantChange,
  tenantValue = null,
  tenantOptions = [],
  isLoadingTenants = false,
  tenantLabel = "Tenant",
}) => {
  const { t } = useTranslation();
  const activeColorStyle = useMemo(() => getActiveColorStyle(activeColor), [activeColor]);
  const filterSelectStyles = useMemo(
    () => getTheme2SearchFilterSingleSelectStyles(activeColorStyle, isTheme2),
    [activeColorStyle, isTheme2]
  );
  const filterColProps = getTheme2SearchFilterColProps(isTheme2, {
    filterColClass: "search-users-filter-col",
    md: "4",
  });

  return (
    <Form>
      <Row className={isTheme2 ? "search-users-filters-row" : "mb-0"}>
        <Col {...filterColProps}>
          <FormGroup>
            <Label>{searchLabel ?? t("searchDeals.search")}</Label>
            <Input
              type="text"
              placeholder={searchPlaceholder}
              value={searchInput}
              onChange={(e) => onSearchChange(e.target.value)}
              className="form-control"
            />
          </FormGroup>
        </Col>
        {showTenantFilter && typeof onTenantChange === "function" ? (
          <Col {...filterColProps}>
            <FormGroup>
              <Label>{tenantLabel}</Label>
              <Select
                activeColor={activeColor}
                className="react-select"
                styles={filterSelectStyles}
                placeholder={tenantLabel}
                name="tenant"
                isSearchable
                closeMenuOnSelect={true}
                value={tenantValue}
                onChange={(option) => onTenantChange(option?.value || "")}
                options={tenantOptions}
                isClearable
                isDisabled={isLoadingTenants}
              />
            </FormGroup>
          </Col>
        ) : null}
      </Row>
    </Form>
  );
};

export default UsersFilters;